import XlsReport from './xls-report.js';

export default XlsReport;
